// extracted by mini-css-extract-plugin
export default {"leadCountByVoivodeship":"LeadCountByVoivodeship_leadCountByVoivodeship__NiTk8","item":"LeadCountByVoivodeship_item__6BTvp"};